export default __webpack_public_path__ + "static/media/BBlogo.be44ef71.svg";